<template>
  <div class="attribute-label"
    :class="classes"
  >
    <div class="attribute-label__icon" @click="toggleSelect()" >
      <component class="svg" :is="iconComponent" :color="getColor"></component>
    </div><!-- /.attribute-label__icon -->

    <div class="attribute-label__title" :class="['color--' + getColor]" @click="toggleSelect()" >
      <div class="attribute-label__title__wrap">
        {{ title }}
        <HelpTooltip :followMouse="false" v-if="tooltip !== false" class="attribute-label__title__help" :link="link" :description="tooltip"></HelpTooltip>
      </div>
    </div>

    <div class="attribute-label__toggle" @click="toggleOpen()">
      <ToggleArrow :width="8" :closed="!open"></ToggleArrow>
    </div>
    <!-- /.attribute-label__toggle -->

  </div><!-- /.attribute-label -->
</template>

<script>
import HelpTooltip from './../../misc/HelpTooltip.vue'
import ToggleArrow from '../shared/ToggleArrow.vue'

import ChecksOnGovernmentIcon from './assets/ChecksOnGovernmentIcon'
import ParticipatoryEngagementIcon from './assets/ParticipatoryEngagementIcon'
import RepresentativeGovernmentIcon from './assets/RepresentativeGovernmentIcon'
import FundamentalRightsIcon from './assets/FundamentalRightsIcon'
import ImpartialAdministrationIcon from './assets/ImpartialAdministrationIcon'

export default {
  name: 'attribute-label',
  components: {
    HelpTooltip,
    ToggleArrow,
    ChecksOnGovernmentIcon,
    ParticipatoryEngagementIcon,
    RepresentativeGovernmentIcon,
    FundamentalRightsIcon,
    ImpartialAdministrationIcon
  },
  props: {
    'title': {
      type: String,
      required: true
    },
    'identifier': {
      type: String,
      required: true
    },
    'color': {
      type: String,
      required: true
    },
    'tooltip': {
      default: false
    },
    'link': {
      default: false
    },
    'open': {
      type: Boolean,
      default: false
    },
    'selected': {
      type: Boolean,
      default: false
    }
  },
  mounted () {
  },
  data () {
    return {
    }
  },
  created () {},
  computed: {
    getColor () {
      if (this.selected) {
        return this.color
      } else {
        return 'gray'
      }
    },
    iconComponent () {
      if (this.identifier === 'A_01') return RepresentativeGovernmentIcon
      if (this.identifier === 'A_02') return FundamentalRightsIcon
      if (this.identifier === 'A_03') return ChecksOnGovernmentIcon
      if (this.identifier === 'A_04') return ImpartialAdministrationIcon
      if (this.identifier === 'A_05') return ParticipatoryEngagementIcon
    },
    classes () {
      let classes = {
        'isOpen': (this.open === true),
        'isSelected': (this.selected === true)
      }
      classes['color--' + this.color] = true

      return classes
    }
  },
  methods: {
    toggleOpen () {
      this.$emit('toggleOpen', !this.open)
    },
    toggleSelect () {
      this.$emit('toggleSelect', !this.selected)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '~@/components/sass/shared/colors';
  @import '~@/components/sass/shared/fonts';

  .attribute-label{
    cursor: pointer;
    display: flex; -js-display: flex;
    line-height: 1.2;
    font-weight: 600;
    position: relative;

    &:not(.isSelected),
    &:not(.isSelected):before {
      color: $gray-darkest;
    }
  }

  .attribute-label__title{
    align-items: center;
    display: flex; -js-display: flex;
    flex: 1 1 auto;
  }
  .attribute-label__title__wrap{
    flex: 1 1 auto;
  }

  .attribute-label:not(.isSelected) .attribute-label__title{
    color: $gray-darkest;
  }

  .attribute-label__icon{
    align-items: center;
    display: flex; -js-display: flex;
    flex: 0 0 30px;
    justify-content: center;
    margin-right: 10px;
    width: 30px;
    position: relative;
  }
  .attribute-label__icon.isSelected .attribute-label__icon:before,
  .attribute-label__icon:hover .attribute-label__icon:before:before{
    display: block;
    content:"\00b7";
    font-size: 30px;
    line-height: 18px;
    position: absolute;
    left: -32px;
  }

  .attribute-label__title__help{
    margin-bottom: -2px;
    margin-left: 3px;
  }

  .attribute-label__toggle{
    align-items: center;
    display: flex; -js-display: flex;
    font-size: 10px;
    flex: 0 0 30px;
    justify-content: flex-end;
    width: 30px;
  }

  .attribute-label__icon__image{ width: 30px; }

</style>



// WEBPACK FOOTER //
// src/components/shared/navigation/AttributesNavigation/AttributeLabel.vue